import { render, staticRenderFns } from "./epidemicRes.vue?vue&type=template&id=89a0c610&scoped=true"
import script from "./epidemicRes.vue?vue&type=script&lang=js"
export * from "./epidemicRes.vue?vue&type=script&lang=js"
import style0 from "./epidemicRes.vue?vue&type=style&index=0&id=89a0c610&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a0c610",
  null
  
)

export default component.exports